import { render, staticRenderFns } from "./_loading.vue?vue&type=template&id=2eaa5134"
import script from "./_loading.vue?vue&type=script&lang=js"
export * from "./_loading.vue?vue&type=script&lang=js"
import style0 from "./_loading.vue?vue&type=style&index=0&id=2eaa5134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports